<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.balance">
        <span :class="$style.label">{{ $t('payout.header.balance') }}:</span>
        <span :class="$style.amount">{{ balance }}</span>
      </div>
      <div :class="$style.payout">
        <div :class="$style.amount">
          {{ available }}
        </div>
        <div :class="$style.available" @click="handleShownPayoutInfo">
          <span :class="$style.label">
            {{ $t('payout.header.available') }}
          </span>
          <span :class="$style.icon">
            <info-icon v-fill:white />
          </span>
        </div>
      </div>
    </div>

    <payout-info-dialog
      v-model="isShownPayoutInfo"
      :content="payoutInfoData"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import InfoIcon from 'atoms/icons/notifications/Info';
import PayoutInfoDialog from 'organisms/payout/components/PayoutInfoDialog';

export default {
  name: 'PayoutHeader',
  components: {
    InfoIcon,
    PayoutInfoDialog,
  },
  props: {
    balance: {
      type: String,
      required: true,
    },
    available: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payoutInfoData: {},
      isShownPayoutInfo: false,
    };
  },
  methods: {
    async handleShownPayoutInfo() {
      try {
        const data = await this.getAvailablePayoutAmounts();

        this.payoutInfoData = data;
        this.isShownPayoutInfo = true;
      } catch (error) {
        console.error(error);
      }
    },
    ...mapActions('project', [
      'getAvailablePayoutAmounts',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .content
    padding: 20px
    background: linear-gradient(249.76deg, #24A84D -8.32%, #068ACC 108.85%), rgba(255, 255, 255, 0.5)
    border-radius: 20px 20px 0px 0px

  .label
    font-weight: 500
    font-size: 12px
    line-height: 14px
    color: #fff

  .amount
    font-weight: 500
    font-size: 18px
    line-height: 22px
    color: #fff

  .balance
    display: flex
    align-items: center
    justify-content: flex-end
    margin-bottom: 10px

    .label
      padding-right: 10px
      opacity: 0.5

    .amount
      line-height: 25px

  .payout
    display: flex
    flex-direction: column
    align-items: center
    margin-bottom: 20px

    .label
      white-space: nowrap
      padding-right: 10px
      opacity: 0.8

    .amount
      font-size: 48px
      line-height: 59px
      margin-bottom: 5px

  .available
    display: flex
    align-items: center
    cursor: pointer

  .icon
    svg
      width: auto
</style>
